export const styles = {
  link: {
    color: 'text',
    mr: 5,
  },
};
